import { useState } from 'react';
import { AdminPreQualificationDetail } from '../models/preQualificationModel';
import buildPreQualificationPdf, {
  ResolvedImage,
} from '../adapters/preQualificationPdfAdapter';

const isImageUrl = (url: string): boolean =>
  /\.(jpg|jpeg|png|gif|webp)$/i.test(url);

const fetchImageAsDataUrl = (url: string): Promise<ResolvedImage> =>
  new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          const dataUrl = reader.result as string;
          const img = new Image();
          img.onerror = reject;
          img.onload = () => {
            resolve({
              url,
              dataUrl,
              width: img.naturalWidth,
              height: img.naturalHeight,
            });
          };
          img.src = dataUrl;
        };
        reader.readAsDataURL(blob);
      })
      .catch(reject);
  });

const usePreQualificationPdf = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generatePdf = async (
    pq: AdminPreQualificationDetail,
  ): Promise<void> => {
    setIsGenerating(true);
    try {
      const imageUrls = new Set<string>();
      pq.questions.forEach((question) => {
        question.responses.forEach((response) => {
          if (Array.isArray(response.value)) {
            response.value.forEach((value) => {
              if (isImageUrl(value)) imageUrls.add(value);
            });
          }
        });
      });

      const images = new Map<string, ResolvedImage>();
      await Promise.all(
        Array.from(imageUrls).map(async (url) => {
          try {
            const resolved = await fetchImageAsDataUrl(url);
            images.set(url, resolved);
          } catch (error) {
            console.error(`Failed to load image for PDF: ${url}`, error);
          }
        }),
      );

      const doc = buildPreQualificationPdf(pq, images);
      doc.save(`precalificacion-${pq.id}.pdf`);
    } finally {
      setIsGenerating(false);
    }
  };

  return { isGenerating, generatePdf };
};

export default usePreQualificationPdf;
